export enum GoalFilter {
  Any = 'any',
}
